import { Form, Input } from "decorator-form";
import React from "react";

import CompositeMultimedia from "common/components/CompositeMultimedia";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { ITab } from "common/views/tab/Tabs.view";
import TypographyView from "common/views/typographyView/Typography.view";
import Label from "core/components/label/Label";
import { ArticleTypeRegistry, IArticleType, IArticleTypeComponentProps } from "../IArticleType";

/**
 * an article view/layout with a video player and interactive transcript
 *
 *
 * WORK IN PROGRESS, COMMITTING FOR DIA DEMO
 */

const typeSelect = ButtonSelect.registerWithOptions<string>([
	{value: 'video', label: <Label k="media.video" v="Video" />},
	{value: 'audio', label: <Label k="media.audio" v="Audio" />}
], { fill: false });

@Form()
class JetpackArticle {

	@Input({
		type: InputType.UPLOAD_URL,
		title: "Video/Audio file"
	})
	public url: string;

	@Input({
		type: InputType.TEXT,
		title: "Aspect Ratio",
		description: "default: 16:9"
	})
	public aspectratio: string = "16:9";

	@Input({
		type: typeSelect,
		title: "Type"
	})
	public type: "video" | "audio";

	@Input({
		type: InputType.UPLOAD_URL_IMAGE,
		title: "Poster Image"
	})
	public poster: string;

	@Input({
		type: InputType.UPLOAD_URL,
		title: "Transcript"
	})
	public transcriptUrl: string;

	public tabs?: Array<{ key: string; label: string; content: string; }>;
}


function JetpackArticleComponent({ article, attachmentDisplay, contributorDisplay, uiSchema }: IArticleTypeComponentProps<JetpackArticle>) {

	const tabs: ITab[] = [];

	if (article.contributors && article.contributors.length) {
		tabs.push({
			key: 'contributors',
			label: <Label k="article.contributors" v="Contributors" />,
			content: contributorDisplay
		});
	}

	if (attachmentDisplay) {
		tabs.push({
			key: 'attachments',
			label: <Label k="article.attachments" v="Attachments" />,
			content: attachmentDisplay
		});
	}

	if (uiSchema.tabs) {
		uiSchema.tabs.forEach((t) => tabs.push({
			key: t.key,
			label: <Label k={'tab.' + t.key} v={t.label} />,
			content: <TypographyView viewKey="tab.content" html={t.content} />
		}));
	}

	return (
		<CompositeMultimedia
			viewKeyPrefix="jetpack"
			src={uiSchema.url}
			transcript={uiSchema.transcriptUrl}
			poster={uiSchema.poster}
			aspectratio={uiSchema.aspectratio}
			audioMode={uiSchema.url ? uiSchema.url.endsWith('.mp3') || uiSchema.url.endsWith('.aac') : false}
			tabs={tabs}
		/>
	);
}

const jetpack: IArticleType<JetpackArticle> = {
	type: 'article:jetpack',
	label: 'Multimedia (Jetpack)',
	icon: "media",
	component: JetpackArticleComponent,
	configClass: JetpackArticle
};

export default ArticleTypeRegistry.putObject(jetpack);



// WEBPACK FOOTER //
// ./src/panels/kb/article/articleType/JetpackArticle.reg.tsx